var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatMuteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_129_2",
    "data-name": "Component 129 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 18,
    height: 18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M19.275,13.016",
    transform: "translate(-3.916 -2.587)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-mute-outline",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M78.143,94.143,64,80",
    transform: "translate(-62.714 -79.999)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M39.714,97.638V99a.161.161,0,0,0,.047.113l.964.964A.161.161,0,0,0,41,99.96V96.981a.986.986,0,0,0-.509-.873.961.961,0,0,0-1.027.074l-.027.021-1.283,1.051a.161.161,0,0,0-.012.238l.685.685a.161.161,0,0,0,.216.01Zm0,9.569-3.137-2.568a1.286,1.286,0,0,0-.815-.288H33.286v-3.857h2.038a.161.161,0,0,0,.113-.274l-.964-.964a.161.161,0,0,0-.113-.047h-1.4a.964.964,0,0,0-.964.964v4.5a.964.964,0,0,0,.964.964h2.8l3.671,3.005.027.02a.961.961,0,0,0,1.039.068.984.984,0,0,0,.5-.866v-2.016a.161.161,0,0,0-.047-.113l-.964-.964a.161.161,0,0,0-.274.113ZM35.77,105.637Zm9.088-3.214a6.175,6.175,0,0,0-.713-2.864.643.643,0,1,0-1.145.584,4.919,4.919,0,0,1,.573,2.279q0,.161-.012.327a.321.321,0,0,0,.093.251l.79.79a.161.161,0,0,0,.271-.08A5.9,5.9,0,0,0,44.857,102.422Zm2.571,0A8.713,8.713,0,0,0,46.055,97.6a.643.643,0,1,0-1.111.648,7.463,7.463,0,0,1,1.2,4.176,7.3,7.3,0,0,1-.376,2.437.321.321,0,0,0,.076.332l.674.673a.161.161,0,0,0,.262-.051A8.4,8.4,0,0,0,47.429,102.422Z",
    transform: "translate(-32 -95.351)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M403.191,87.058a11.519,11.519,0,0,0-2.029-6.775.643.643,0,1,0-1.085.692,10.342,10.342,0,0,1,1.829,6.083,10.107,10.107,0,0,1-.948,4.54.161.161,0,0,0,.031.183l.716.717a.161.161,0,0,0,.257-.04A11.276,11.276,0,0,0,403.191,87.058Z",
    transform: "translate(-385.191 -79.986)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatMuteIcon);
export default __webpack_public_path__ + "static/media/live-chat-mute-icon.606979b4c3a9e331b793a96ef1be7be6.svg";
export { ForwardRef as ReactComponent };